import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ccc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

/** API list endpoints should return JSON arrays; coerce bad/HTML responses to []. */
export const asArray = (data) => (Array.isArray(data) ? data : []);

export const currency = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

